import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Constants } from '../../../constants/ebtq-constants';
import { SubmitTrialBalance } from '../../../model/submitTrialBalance';
import { TransactionWrapper } from '../../../model/transactionWrapper';
import { ApiService } from '../../../services/api.service';
import { UtilityService } from '../../../services/utility-service';
import {Title} from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-submit-trial-balance',
  templateUrl: './submit-trial-balance.component.html',
  styleUrls: ['./submit-trial-balance.component.scss']
})
export class SubmitTrialBalanceComponent implements OnInit {
  warningMessage: string;
  errorMessage: string[] = [];
  containsError = false;
  errorMsg: string;
  balance: SubmitTrialBalance;
  isExternal: boolean;

  serNumber = [{ label: '912', value: '912' }, { label: '952', value: '952' }];
  pmtPlanOpts = [{ label: 'Term', value: '1' }, { label: 'Tenure', value: '2' },
    { label: 'Modified Term', value: '3' }, { label: 'Modified Tenure', value: '4' },
    { label: 'Line of Credit', value: '5' }];

  title = 'Submit Trial Balance';

  submitTrialBalanceForm = new UntypedFormGroup({
    loanNumber: new UntypedFormControl(''),
    reportingPeriod: new UntypedFormControl(''),
    fhaCaseNumber: new UntypedFormControl(''),
    fhaNumber2: new UntypedFormControl(''),
    interestRate: new UntypedFormControl(''),
    paymentPlan: new UntypedFormControl(''),
    loanBalance: new UntypedFormControl(''),
    netPrinLimit: new UntypedFormControl(''),
    origLoc: new UntypedFormControl(''),
    netLoc: new UntypedFormControl(''),
    yearPropChgs: new UntypedFormControl(''),
    taxOrIns: new UntypedFormControl(''),
    repairs: new UntypedFormControl(''),
    servicingFee: new UntypedFormControl(''),
    schdPayment: new UntypedFormControl(''),
    term: new UntypedFormControl(''),
    closingDate: new UntypedFormControl(''),
    borrowerBirthDate: new UntypedFormControl(''),
    expAvgIntRate: new UntypedFormControl(''),
    maxClaimAmt: new UntypedFormControl(''),
    margin: new UntypedFormControl(''),
    serviceFee: new UntypedFormControl(''),
  });

  constructor(private _apiService: ApiService, private _router: Router,
      private _utilService: UtilityService, private titleService: Title, private cdr: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.titleService.setTitle(this.title);
    this.isExternal = JSON.parse(sessionStorage.getItem('isExternal'));
    this.errorMessage = [];
    this.warningMessage = '';
    this.submitTrialBalanceForm.reset();
    this.submitTrialBalanceForm.controls['fhaNumber2'].setValue('912');
    this.submitTrialBalanceForm.controls['paymentPlan'].setValue('1');
  }

  public submitBalanceForm(): void {
    this.warningMessage = '';
    if (this.validate()) {
      return;
    }
    this.checkValidUser(this.balance.loanNumber);
  }

  onClear(): void {
    this.errorMessage = [];
    this.warningMessage = '';
    this.submitTrialBalanceForm.reset();
    this.submitTrialBalanceForm.controls['fhaNumber2'].setValue('912');
    this.submitTrialBalanceForm.controls['paymentPlan'].setValue('1');
  }
  /**
 * Check loan number is valid and user is Authorized for this action
 * If yes then submit trail balance form
 * @param loanNumber
 */
  private checkValidUser(loanNumber: string) {
    const transactionWrapper = new TransactionWrapper();
    transactionWrapper.queryServiceName = Constants.QUERY_SERV_NAME;
    transactionWrapper.parameters[0] = loanNumber;

    this._apiService.executeQuery(transactionWrapper)
      .subscribe(
        (data: any) => {
          if (data.object[0] === undefined || data.object[0].SRVR_NO === undefined || data.object[0].SRVR_NO === null) {
            this.errorMessage.push(Constants.FAN_LN_INVLID.replace('{0}', loanNumber)) ;
          } else {
            const srvrNo = data.object[0].SRVR_NO;
            if (!this._utilService.isUserAuthorizedForServicerNumber(srvrNo)) {
              this.errorMessage.push(Constants.USR_NOT_AUTH_PERFORM.replace('{0}', loanNumber));
            } else {
              this.executeTransaction();
            }
          }
          this.cdr.detectChanges();
        },
        (err) => {
          this.errorMsg = err;
          this.containsError = true;
          this.cdr.detectChanges();
        });

  }
  /**
   * Submitting user provided trial balance details
   */
  executeTransaction() {
    //Creating comma seperated service numbers for  external user
    this.balance.isExternal = JSON.parse(sessionStorage.getItem('isExternal'));
    const srvrList = JSON.parse(sessionStorage.getItem('authServicerNumbersArr'));
    if (srvrList != null) {
      let srvrNmbrs = '';
      for (let i = 0; i < srvrList.length; i++)
      {
        srvrNmbrs = srvrNmbrs.concat(srvrList[i]).concat(',');
      }
      this.balance.srvrNumbers = srvrNmbrs.substring(0, srvrNmbrs.length - 1);
    }
    this._apiService.executeSubmitTrial(this.balance).subscribe(
      (data) => {
        if (!data || data.length === 0) {
          this.warningMessage = 'No Loan data found.';
          this.cdr.detectChanges();
          return;
        }
        this._router.navigate(['trialBalanceResult'], {
          queryParams: {loanNumber: this.balance.loanNumber, rptDate: this.balance.reportingPeriod, result: btoa(JSON.stringify(data)), mainPage: 'submitTrialBalance'}
        });
      }, (err) =>{
        this.errorMessage.push(err);
        this.cdr.detectChanges();
      }
    );
  }
  /**
 * Method to validate the form befor submitting
 * @returns boolean
 */
  validate() {
    this.errorMessage = [];
    this.balance = this.submitTrialBalanceForm.value;
    if (!this.isNotEmpty(this.balance.loanNumber) || this.balance.loanNumber.length !== 10 || !/^[0-9]+$/.test(this.balance.loanNumber)) {
      this.errorMessage.push('Fannie Mae loan numbers must be ten-digits.');
    }
    if (!this.isNotEmptyDate(this.balance.reportingPeriod)) {
      this.errorMessage.push('Reporting period must be in the MM/YYYY format');
    } else {
      this.balance.reportingPeriod = this._utilService.milliSecToMMYYYY(this.submitTrialBalanceForm.value.reportingPeriod);
    }
    if (this.isNotEmpty(this.balance.fhaCaseNumber) && !this.isValidString(this.balance.fhaCaseNumber)) {
      this.errorMessage.push('FHA Case Number contains invalid characters');
    }
    else if (!this.isNotEmpty(this.balance.fhaCaseNumber))
    {
      this.balance.fhaCaseNumber = null;
    }
    if (this.isNotEmpty(this.balance.fhaNumber2) && !this.isValidString(this.balance.fhaNumber2)) {
      this.errorMessage.push('FHA Case Number contains invalid characters');
    }
    if (this.isNotEmpty(this.balance.interestRate) && !this.isFloat(this.balance.interestRate)) {
      this.addError('Interest Rate');
    } if (this.isNotEmpty(this.balance.paymentPlan) && !this.isValidString(this.balance.paymentPlan)) {
      this.errorMessage.push('Payment Plan contains invalid characters');
    } if (this.isNotEmpty(this.balance.loanBalance) && !this.isFloat(this.balance.loanBalance)) {
      this.addError('Loan Balance');
    } if (this.isNotEmpty(this.balance.origLoc) && !this.isFloat(this.balance.origLoc)) {
      this.addError('Orig Line Of Credit');
    } if (this.isNotEmpty(this.balance.netLoc) && !this.isFloat(this.balance.netLoc)) {
      this.addError('Net Line Of Credit');
    } if (this.isNotEmpty(this.balance.netPrinLimit) && !this.isFloat(this.balance.netPrinLimit)) {
      this.addError('Net Prin Limit');
    } if (this.isNotEmpty(this.balance.yearPropChgs) && !this.isFloat(this.balance.yearPropChgs)) {
      this.addError('1st Year Prop Chgs');
    } if (this.isNotEmpty(this.balance.taxOrIns) && !this.isFloat(this.balance.taxOrIns)) {
      this.addError('Tax/Insurance');
    } if (this.isNotEmpty(this.balance.repairs) && !this.isFloat(this.balance.repairs)) {
      this.addError('Repairs');
    } if (this.isNotEmpty(this.balance.servicingFee) && !this.isFloat(this.balance.servicingFee)) {
      this.addError('Servicing Fee');
    } if (this.isNotEmpty(this.balance.schdPayment) && !this.isFloat(this.balance.schdPayment)) {
      this.addError('Scheduled Payment');
    } if (this.isNotEmpty(this.balance.term) && !this.isLong(this.balance.term)) {
      this.addError('Loan Term');
    } if (this.isNotEmptyDate(this.balance.closingDate) ) {
      this.balance.closingDate = this._utilService.convertMillisecToDate(this.submitTrialBalanceForm.value.closingDate);
    } if (this.isNotEmptyDate(this.balance.borrowerBirthDate) ) {
      this.balance.borrowerBirthDate = this._utilService.convertMillisecToDate(this.submitTrialBalanceForm.value.borrowerBirthDate);
    } if (this.isNotEmpty(this.balance.expAvgIntRate) && !this.isFloat(this.balance.expAvgIntRate)) {
      this.addError('Exp Avg Int Rate');
    } if (this.isNotEmpty(this.balance.maxClaimAmt) && !this.isFloat(this.balance.maxClaimAmt)) {
      this.addError('Max Claim Amount');
    } if (this.isNotEmpty(this.balance.margin) && !this.isFloat(this.balance.margin)) {
      this.addError('Margin');
    } if (this.isNotEmpty(this.balance.serviceFee) && !this.isFloat(this.balance.serviceFee)) {
      this.addError('Service Fee');
    }
    return this.errorMessage.length > 0;
  }

  private addError(field: string) {
    this.errorMessage.push(Constants.TRIALBAL_ERR_FORMAT.replace('{0}', field));
  }

  private isNotEmpty(field: string) {
    return field !== undefined && field !== null && field.trim() !== '' ;
  }

  private isNotEmptyDate(field: string) {
    return field !== undefined && field !== null && field !== '' ;
  }

  private isValidString(field: string) {
    return field !== 'null';
  }

  private isLong(filed: string) {
    return /^[-]?[0-9]+$/.test(filed);
  }
  private isFloat(filed: string) {
    const value = parseFloat(filed);
    return !isNaN(value);
  }
}
